module.exports = __webpack_public_path__ + "img/bgimg.d925dc5f.png";